<template lang="pug">
  #product-Single
      .container
        .row
          .col-sm-12
            bk-migas(:migas="migasSend" @toFilterCategory="toFilterCategory")
      bk-product(v-if="id" :id="id" @toGoProduct="toGoProduct" @toAddCart="toAddCart" @toSendMigas="toSendMigas"  @showMessage="showModalMsgStockOnRequest")
      bk-modal(ref="modalCommon" id="stockonrequest" :title="modal.title" :content="modal.content" :footer="modal.footer" )
      p.hidden
        button(data-toggle="modal" data-target="#stockonrequest" class="btn-modal" ref="showModal")
</template>
<script>
import {mapGetters} from 'vuex'

import BkMigas from '@/components/catalog/Migas-list.vue'
import BkProduct from '@/components/catalog/Product.vue'
import BkModal from '@/components/common/Modal.vue'

export default {
  name: 'ProductSingle',
  components: { BkMigas, BkProduct, BkModal },
  props: ['id', 'migas'],
  data () {
    return {
      migasSend: [],
      'modal': {
        'title': '',
        'content': '',
        'footer': ''
      }
    }
  },
  computed: {
    ...mapGetters([
      'role'
    ]),
    isTypeApp () {
      // console.log(`--- typeApp: ${this.$config.type}`)
      return this.$config.type
    },
    config_app () {
      // console.log('----++', this.$config.configApp)
      return this.$config.configApp
    }
  },
  created () {
    // console.log('----------+', this.migas)

  },
  methods: {
    showModalMsgStockOnRequest (titulo, msg) {
      const labelBtn = this.$gettext('Aceptar')
      this.modal.title = titulo
      this.modal.content = `<p style="text-align:center;padding-top:20px;">${msg}</p>
                            <p style="margin-top:40px;text-align:center;"><button type="button" data-dismiss="modal" class="btn btn-action">${labelBtn}</button></p>`
      // En el HTML hay un botón con el atributo ref="showModal" y de esta forma le hacemos click para mostrar la modal.
      this.$refs.showModal.click()
    },
    toFilterCategory (v) {
      // console.log(`--- toFilterCategory: ${v}`)
      this.$router.push({'name': 'catalogoList', 'params': {'catProductSingle': {id: v}}})
    },
    toAddCart (item) {
      // console.log(`Component page/CatalogoList -> id product: ${item.idProduct}, quantity: ${item.quantity} , item: `, item.product)
      // Envia al carrito
      // alert('Product single: Enviamos a la Store del carrito.')
      this.$store.dispatch('addCart', item)

      // Y redirijimos al catálogo
      // this.$router.go(-1)
    },
    toGoProduct (id) {
      // console.log(`-----> toGoProduct: ${id}`)
      this.idProduct = id
      this.$router.push({'name': 'productSingle', 'params': {'id': id.toString(), 'migas': this.migas}})
    },
    toSendMigas (migas) {
      this.migasSend = migas
    }
  },
  watch: {
    migas () {
      // console.log('--------->migas:', this.migas)
    }
  }
}
</script>
<style lang="scss" scoped>

#catalog-migas{
  padding-left: 0;
}

</style>
